import { put, call, all, takeEvery, delay, select } from "redux-saga/effects";
import scorecardActions from "./actions";
import axios from "axios";
import { API_URL } from "../../utils/constants";
import commonActions from "../common/actions";
import Cookies from "js-cookie";
import setAuthToken from "../../utils/setAuthToken";

const scorecardSagas = function* () {
  yield all([
    yield takeEvery(
      scorecardActions.UPLOAD_CANDIDATE_DATA,
      candidateDataUpload
    ),
    yield takeEvery(scorecardActions.GENERATE_SCORE_DATA, generateScoreData),
    yield takeEvery(scorecardActions.GENERTAE_SCORECARD_PDF, generateScoreCardPdf),
    yield takeEvery(scorecardActions.GET_SCORE_DATA, getScoreData),
    yield takeEvery(scorecardActions.RESET_GENERATED_DATA, resetGeneratedData),
    yield takeEvery(
      scorecardActions.GET_GENERATED_SCORE_DATA,
      getGeneratedScoreData
    ),
  ]);
};

const candidateDataUpload = function* (data) {
  const { payload } = data;
  // const { getDataInterval, setIntervalId } = payload;
  payload?.setLoading(true);
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    let formData = new FormData();
    const documentFile = new File([payload?.file], payload?.file.name, {
      type: "application/xlsx",
    });
    formData.append("candidateData", documentFile);
    formData.append("userid", payload?.id);
    formData.append("isExternalData", payload?.isExternalData);

    //   formData.append("courseid", payload?.courseid);
    const result = yield call(() =>
      axios.post(
        `${API_URL}/backoffice/scorecard/candidatedata/${payload?.courseid}`,
        formData
      )
    );
    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
    payload?.setLoading(false);

    if (result?.data?.statusCode === 200) {
      payload?.setFile(null);
      payload?.setOpen({
        open: false,
        type: null,
      });
      // payload?.setStatusModalOpen({
      //   open: true,
      //   statustext: "Processing...",
      // });
      // let intervalId = getDataInterval(payload?.courseid, result?.data?.data);
      // setIntervalId(intervalId);
    }

    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        // message: result?.data?.message,
        message:
          result?.data?.statusCode === 200
            ? "Score data upload has started. Use Refresh to check the status after some time."
            : result?.data?.message,
      },
    });

    // yield put({
    //     type: rollNumberActions.SET_BATCH_CANDIDATES,
    //     payload: (result?.data?.statusCode === 200) ? result?.data?.data : []
    // });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  } catch (err) {
    payload?.data?.setLoading(false);
  }
};
const generateScoreData = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.post(
        `${API_URL}/backoffice/scorecard/generatescoredata`,
        {
          courseid: payload?.courseid,
          isExternalData: payload?.isExternalData,
          userid: payload?.userid,
          generatemethod: payload?.generateMethod
        }
      )
    );
    // if (result?.data?.statusCode === 200) {
    //   payload?.setStatusModalOpen({
    //     open: true,
    //     statustext: "Processing...",
    //   });
    //   let intervalId = payload?.getScoreGenerateInterval(payload?.courseid, result?.data?.result);
    //   payload?.setIntervalId(intervalId);
    //   yield put({
    //     type: scorecardActions.SET_GENERATED_SCORE_DATA,
    //     payload: result?.data?.result,
    //   });
    //   yield put({ type: scorecardActions.SET_GENERATED_SCORE_DATA, payload: [] })
    // }
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });

    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        // message: result?.data?.message,
        message:
          result?.data?.statusCode === 200
            ? "Score card data generation has started. Use Refresh to check the status after some time."
            : result?.data?.message,
      },
    });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  } catch (err) {
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};
const generateScoreCardPdf = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/backoffice/scorecard/scorecard-batch`, {
        courseid: payload?.courseid,
        isExternalData: payload?.isExternalData,
        userid: payload?.userid,
        generatemethod: payload?.generateMethod,
      })
    );

    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  } catch (err) {
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: "failed",
        show: true,
        message: "Failed to generate score card PDF",
      },
    });
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getScoreData = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });

  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/backoffice/scorecard/candidatedata/${payload?.courseid}/${payload?.isExternalData}`
      )
    );
    if (result?.data?.statusCode === 200) {
      yield put({
        type: scorecardActions.SET_SCORE_DATA,
        payload: result?.data?.data,
      });
    }
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  } catch (err) {}
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};
const resetGeneratedData = function* (data) {
  const { payload } = data;

  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/backoffice/scorecard/resetgenerateddata/${payload?.courseid}/${payload?.isExternalData}`
      )
    );
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  } catch (err) {
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const getGeneratedScoreData = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/backoffice/scorecard/getgeneratedscoredata/${payload?.courseid}/${payload?.isExternalData}`
      )
    );
    if (result?.data?.statusCode === 200) {
      yield put({
        type: scorecardActions.SET_GENERATED_SCORE_DATA,
        payload: result?.data?.result,
      });
    }
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  } catch (err) {
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  }
  // yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};
export default scorecardSagas;
